import { memo } from 'react';
import cn from 'classnames';
import type { NodeToRenderProps, NodeToRenderMessageData } from './types/custom-nodes.type';
import { applyGenericHocs } from '@src/scenario-editor/utils';
import { CustomTooltip } from '../tooltip/Tooltip';
import { Icon } from '@src/components/icon/Icon';

export const MenuItem = ({ children, className, ...props }: NodeToRenderProps) => {
  return (
  <div
    className={
      cn([
        "flex rounded-md p-2 border-2 border-transparent bg-white h-full justify-center items-center w-fit text-sm truncate",
        className,
      ])
    }
    {...props}
  >{children}</div>
)};

export const NodeItem = ({ data, ...props }: NodeToRenderProps) => {
  const { message } = data as NodeToRenderMessageData;
  return (
    <div
      className={
        cn([
          props.className,
          "flex flex-col py-2 px-2 rounded-md border-2 border-transparent bg-white justify-center items-center w-fit text-sm h-[94px]",
        ])
      }
      style={props.style}
    >
      <div><Icon type="info" variant="nodeIcon" size="large" /></div>
      <div className="text-center text-xs pt-2">Send message</div>
      {message ? (
        <CustomTooltip content={message}>
          <p className="text-center text-sm font-bold truncate max-w-full break-all">{message}</p>
        </CustomTooltip>
      ) : (
        <p className="text-center text-sm text-label-foreground font-bold truncate max-w-full break-all">Add message</p>
      )}

    </div>
  )
};

const WrappedNodeToRender = applyGenericHocs(NodeItem);

const MessageInfo: React.FC<NodeToRenderProps> = (props: NodeToRenderProps) => {
  const { title } = props.data as NodeToRenderMessageData;
  return (
    <>
      <WrappedNodeToRender {...props}>{title}</WrappedNodeToRender>
    </>
  );
};

export const MessageInfoNode = memo(MessageInfo);
